// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase';

Vue.config.productionTip = false

// Initialize Firebase

firebase.initializeApp({
  apiKey: "AIzaSyBtGBhwnqHAgO8lCbJuaOKRja1x6lB2ETA",
  authDomain: "mitch-fitzsimmons-website.firebaseapp.com",
  databaseURL: "https://mitch-fitzsimmons-website.firebaseio.com",
  projectId: "mitch-fitzsimmons-website",
  storageBucket: "mitch-fitzsimmons-website.appspot.com",
  messagingSenderId: "876419598111"
});

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js